import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
// import Component from 'Scripts/classes/Component'

export default class {
  constructor({ selector }) {
    // super({
    //   elements: {
    //     selector: selector
    //   }
    // })
    this.selector = selector
    //Methods
    // this.elements.selector && this.createObserver()
    this.selector && this.initScrollTrigger()
  }

  initScrollTrigger() {
    // gsap.utils.toArray(this.selector).forEach((elm, index) => {
    gsap.utils.toArray(this.selector).filter(el => !el.classList.contains('is__hidden')).forEach((elm, index) => {
      
      if (elm.dataset.scroll === 'true') {        
        gsap.to(elm, {
          scrollTrigger: {
            id: "inView",
            trigger: elm,
            start: "top bottom",
            markers : false
          },
          delay: index * 0.05,
          onComplete: () => {
            elm.classList.add('is-inview')
          },
          onCompleteParams: [elm],
        })
      } else {

        gsap.to(elm, {
          scrollTrigger: {
            id: "reveal",
            trigger: elm,
            start: "top bottom",
          },
          autoAlpha: 1,
          y: 0,
          x: 0,
          ease: "sine",
          duration: .8,
          delay: index * 0.05,
          // onComplete: IntroCallback,
          // onCompleteParams: [elm],        
        })

      }
    })

  }


  // createObserver() {
  //   this.observer = new window.IntersectionObserver((entries, observer) => {
  //     // console.log(entries)
  //     entries.forEach((entry, index) => {
  //       if (entry.isIntersecting) {
  //         //Animation
  //         gsap.to(entry.target, {
  //           y: 0,
  //           autoAlpha: 1,
  //           duration: 1,
  //           ease: "Power2.easeInOut",
  //           // delay: 0.1 * index,
  //         })
  //         //Unobserve
  //         observer.unobserve(entry.target);
  //       }

  //     })
  //   })

  //   if (this.elements.selector instanceof NodeList) {
  //     this.elements.selector.forEach(section => {
  //       this.observer.observe(section)
  //     })
  //   } else if (this.elements.selector instanceof HTMLElement) {
  //     this.observer.observe(this.selector)
  //   }

  // }
}